import { resolveUploadUrl } from "@/services/filesService";
import { cn } from "@/lib/utils";
import { Package } from "lucide-react";
import { IMAGE_SPECS, type ImageStandardKey } from "@/lib/imageStandards";
import type { ReactNode } from "react";

export interface StandardImageProps {
  src?: string;
  alt?: string;
  standard?: ImageStandardKey;
  /** Tailwind size classes for the container, e.g. h-10 w-10 */
  className?: string;
  rounded?: "none" | "md" | "lg" | "xl";
  fallback?: ReactNode;
}

const roundedClass = {
  none: "",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
};

const StandardImage = ({
  src,
  alt = "",
  standard = "product",
  className,
  rounded = "lg",
  fallback,
}: StandardImageProps) => {
  const spec = IMAGE_SPECS[standard];
  const resolved = src ? resolveUploadUrl(src) : undefined;

  return (
    <div
      className={cn(
        "relative shrink-0 overflow-hidden border border-border bg-white",
        roundedClass[rounded],
        className,
      )}
      style={{ aspectRatio: spec.aspectRatio }}
    >
      {resolved ? (
        <img
          src={resolved}
          alt={alt}
          className="h-full w-full object-contain"
          loading="lazy"
        />
      ) : (
        fallback ?? (
          <div className="flex h-full w-full items-center justify-center bg-muted">
            <Package className="h-5 w-5 text-muted-foreground" />
          </div>
        )
      )}
    </div>
  );
};

export default StandardImage;
